import { NgModule } from '@angular/core';
import { RaisenowModule } from '@app/next/raisenow/raisenow.module';
import { FormPageComponent } from '@app/verify/feature/forms/components/form-page/form-page.component';
import { FmntsIconsModule } from '@fmnts/components/icons';
import { FmntsImageModule } from '@fmnts/components/image';
import { FmntsModalModule } from '@fmnts/components/modal';
import { FmntsProgressIndicatorModule } from '@fmnts/components/progress-indicator';
import { I18nModule } from '@fmnts/i18n';
import { LetDirective, PushPipe } from '@ngrx/component';
import { AuthForSelfCheckoutFormComponent } from './auth-for-self-checkout-form/auth-for-self-checkout-form.component';
import { CheckoutFormComponent } from './checkout-form/checkout-form.component';
import { SelfCheckoutFormsRoutingModule } from './self-checkout-forms-routing.module';
import { SelfCheckoutUnsubscribeComponent } from './self-checkout-unsubscribe/self-checkout-unsubscribe.component';

@NgModule({
  declarations: [
    AuthForSelfCheckoutFormComponent,
    CheckoutFormComponent,
    SelfCheckoutUnsubscribeComponent,
  ],
  providers: [],
  imports: [
    FmntsProgressIndicatorModule,
    FmntsIconsModule,
    FmntsImageModule,
    I18nModule,
    RaisenowModule,
    FmntsModalModule,
    FormPageComponent,
    SelfCheckoutFormsRoutingModule,
    LetDirective,
    PushPipe,
  ],
})
export class SelfCheckoutFormsFeatureModule {}
